import { memo } from "react";
import { IconCheck } from "@tabler/icons-react";

import { Menu, Tooltip } from "@fragments";

const SPEED_OPTIONS = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];

const speedLabel = (rate) => (rate === 1 ? "Normal" : `${rate}×`);

/**
 * SpeedMenu — playback-rate picker; the trigger chip reads the current rate.
 *
 * Menu clones its direct child to wire the open trigger, and Tooltip clones
 * its child for hover — so the wiring is: Menu → span (click anchor) →
 * Tooltip → button. The button's click bubbles to the span, which opens the
 * menu; the bar-level click shield keeps it from reaching the stage.
 */
function SpeedMenu({ speed, onSetSpeed }) {
    const items = SPEED_OPTIONS.map((rate) => ({
        id: `speed-${rate}`,
        label: speedLabel(rate),
        icon: rate === speed ? <IconCheck size={16} /> : null,
        active: rate === speed,
        onClick: () => onSetSpeed(rate),
    }));

    return (
        <Menu items={items} placement="top-start">
            <span className="player-speed-anchor">
                <Tooltip content="Velocidade de reprodução" placement="top">
                    <button
                        type="button"
                        aria-label="Velocidade de reprodução"
                        className="player-control-button player-speed-button"
                    >
                        {speed === 1 ? "1×" : `${speed}×`}
                    </button>
                </Tooltip>
            </span>
        </Menu>
    );
}

export default memo(SpeedMenu);
